export default __webpack_public_path__ + "static/media/icon_qldonhang.3cf3e674.svg";